var _rect, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptySign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 68,
    viewBox: "0 0 162 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 15.2363,
    width: 161.062,
    height: 52.2365,
    rx: 6,
    fill: "#282828"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.9941 37.8184V41.3684H51.7191V44.6684H45.9941V48.5184H52.4691V51.9434H41.7191V34.3934H52.4691V37.8184H45.9941ZM73.0445 37.8434C74.7778 37.8434 76.1528 38.3684 77.1695 39.4184C78.2028 40.4684 78.7195 41.9267 78.7195 43.7934V51.9434H74.4695V44.3684C74.4695 43.4684 74.2278 42.7767 73.7445 42.2934C73.2778 41.7934 72.6278 41.5434 71.7945 41.5434C70.9611 41.5434 70.3028 41.7934 69.8195 42.2934C69.3528 42.7767 69.1195 43.4684 69.1195 44.3684V51.9434H64.8695V44.3684C64.8695 43.4684 64.6278 42.7767 64.1445 42.2934C63.6778 41.7934 63.0278 41.5434 62.1945 41.5434C61.3611 41.5434 60.7028 41.7934 60.2195 42.2934C59.7528 42.7767 59.5195 43.4684 59.5195 44.3684V51.9434H55.2445V37.9934H59.5195V39.7434C59.9528 39.16 60.5195 38.7017 61.2195 38.3684C61.9195 38.0184 62.7111 37.8434 63.5945 37.8434C64.6445 37.8434 65.5778 38.0684 66.3945 38.5184C67.2278 38.9684 67.8778 39.61 68.3445 40.4434C68.8278 39.6767 69.4861 39.0517 70.3195 38.5684C71.1528 38.085 72.0611 37.8434 73.0445 37.8434ZM85.9843 39.9684C86.401 39.3184 86.976 38.7934 87.7093 38.3934C88.4426 37.9934 89.301 37.7934 90.2843 37.7934C91.4343 37.7934 92.476 38.085 93.4093 38.6684C94.3426 39.2517 95.076 40.085 95.6093 41.1684C96.1593 42.2517 96.4343 43.51 96.4343 44.9434C96.4343 46.3767 96.1593 47.6434 95.6093 48.7434C95.076 49.8267 94.3426 50.6684 93.4093 51.2684C92.476 51.8517 91.4343 52.1434 90.2843 52.1434C89.3176 52.1434 88.4593 51.9434 87.7093 51.5434C86.976 51.1434 86.401 50.6267 85.9843 49.9934V58.5934H81.7093V37.9934H85.9843V39.9684ZM92.0843 44.9434C92.0843 43.8767 91.7843 43.0434 91.1843 42.4434C90.601 41.8267 89.876 41.5184 89.0093 41.5184C88.1593 41.5184 87.4343 41.8267 86.8343 42.4434C86.251 43.06 85.9593 43.9017 85.9593 44.9684C85.9593 46.035 86.251 46.8767 86.8343 47.4934C87.4343 48.11 88.1593 48.4184 89.0093 48.4184C89.8593 48.4184 90.5843 48.11 91.1843 47.4934C91.7843 46.86 92.0843 46.01 92.0843 44.9434ZM106.452 48.3184V51.9434H104.277C102.727 51.9434 101.519 51.5684 100.652 50.8184C99.7854 50.0517 99.3521 48.81 99.3521 47.0934V41.5434H97.6521V37.9934H99.3521V34.5934H103.627V37.9934H106.427V41.5434H103.627V47.1434C103.627 47.56 103.727 47.86 103.927 48.0434C104.127 48.2267 104.46 48.3184 104.927 48.3184H106.452ZM123.083 37.9934L114.333 58.5684H109.733L112.933 51.4684L107.258 37.9934H112.033L115.258 46.7184L118.458 37.9934H123.083Z",
    fill: "#F1F1F1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_12141_93832)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.8008,
    width: 8.70608,
    height: 23.9417,
    rx: 4,
    fill: "#636363"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.742,
    width: 8.70608,
    height: 23.9417,
    rx: 4,
    fill: "#636363"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_12141_93832",
    x: 46.8008,
    y: 0,
    width: 69.6484,
    height: 23.9414,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_12141_93832"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySign);
export default __webpack_public_path__ + "static/media/EmptySign.ce8264f351773146b38090f087d299d1.svg";
export { ForwardRef as ReactComponent };